(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-category', {
            parent: 'entity',
            url: '/customer-category?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-category/customer-categories.html',
                    controller: 'CustomerCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-category-detail', {
            parent: 'entity',
            url: '/customer-category/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.customerCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-category/customer-category-detail.html',
                    controller: 'CustomerCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerCategory', function($stateParams, CustomerCategory) {
                    return CustomerCategory.get({id : $stateParams.id});
                }]
            }
        })
        .state('customer-category.new', {
            parent: 'customer-category',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-category/customer-category-dialog.html',
                    controller: 'CustomerCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                circleDaysNo: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-category', null, { reload: true });
                }, function() {
                    $state.go('customer-category');
                });
            }]
        })
        .state('customer-category.edit', {
            parent: 'customer-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-category/customer-category-dialog.html',
                    controller: 'CustomerCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerCategory', function(CustomerCategory) {
                            return CustomerCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-category.delete', {
            parent: 'customer-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-category/customer-category-delete-dialog.html',
                    controller: 'CustomerCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerCategory', function(CustomerCategory) {
                            return CustomerCategory.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-category', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
